import axios from '@axios'

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        fetchAssets(ctx, queryParams) {

            return new Promise((resolve, reject) => {

                axios
                    //.get('/apps/asset/assets', { params: queryParams })
                    .get(`/api/v1/Asset/search?Search=${queryParams.q}&Page=${queryParams.page}&PerPage=${queryParams.perPage}`)
                    //.get(`/api/v1/Asset/search?Page=${queryParams.page}&PerPage=${queryParams.perPage}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        fetchAsset(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    //.get(`/apps/asset/assets/${id}`)
                    .get(`/api/v1/Asset?id=${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        fetchAssetSummary(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    //.get(`/apps/asset/assets/${id}`)
                    .get(`/api/v1/Asset/summary?Id=${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        
        fetchAlarms(ctx, { id = '', assetGroupId = '' }) {
            return new Promise((resolve, reject) => {
                axios
                    //.get(`/apps/user/users/${id}`)
                    .get(`/api/v1/Asset/eventgenerator/search?AssetId=${id}&AssetGroupId=${assetGroupId}&Page=1&PerPage=100`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        addMoveAlarm(ctx, alarm) {
            return new Promise((resolve, reject) => {
                axios
                    //.post('/apps/customer/customers', { customer: customerData })
                    .post('/api/v1/Asset/eventgenerator/move', alarm)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        addAlarmWeekendMove(ctx, alarm) {
            return new Promise((resolve, reject) => {
                axios
                    //.post('/apps/customer/customers', { customer: customerData })
                    .post('/api/v1/Asset/eventgenerator/weekendmove', alarm)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        addIgnitionAlarm(ctx, alarm) {
            return new Promise((resolve, reject) => {
                axios
                    //.post('/apps/customer/customers', { customer: customerData })
                    .post('/api/v1/Asset/eventgenerator/ignition', alarm)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        addSevereAlarm(ctx, alarm) {
            return new Promise((resolve, reject) => {
                axios
                    //.post('/apps/customer/customers', { customer: customerData })
                    .post('/api/v1/Asset/eventgenerator/severeuse', alarm)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        addIddleAlarm(ctx, alarm) {
            return new Promise((resolve, reject) => {
                axios
                    //.post('/apps/customer/customers', { customer: customerData })
                    .post('/api/v1/Asset/eventgenerator/iddleuse', alarm)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        }, 
        addLongTimeAlarm(ctx, alarm) {
            return new Promise((resolve, reject) => {
                axios
                    //.post('/apps/customer/customers', { customer: customerData })
                    .post('/api/v1/Asset/eventgenerator/longtimewithoutconnection', alarm)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        }, 
        addOverSpeedAlarm(ctx, alarm) {
            return new Promise((resolve, reject) => {
                axios
                    //.post('/apps/customer/customers', { customer: customerData })
                    .post('/api/v1/Asset/eventgenerator/overspeed', alarm)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        addHighConsumptionAlarm(ctx, alarm) {
            return new Promise((resolve, reject) => {
                axios
                    //.post('/apps/customer/customers', { customer: customerData })
                    .post('/api/v1/Asset/eventgenerator/highfuelconsumption', alarm)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        addLowFuelAlarm(ctx, alarm) {
            return new Promise((resolve, reject) => {
                axios
                    //.post('/apps/customer/customers', { customer: customerData })
                    .post('/api/v1/Asset/eventgenerator/lowfuel', alarm)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        deleteAlarm(ctx, {id}) {
            return new Promise((resolve, reject) => {
                axios
                    //.post('/apps/customer/customers', { customer: customerData })
                    .delete(`/api/v1/Asset/eventgenerator?Id=${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        addEngineCoolantTemperatureAlarm(ctx, alarm) {
            return new Promise((resolve, reject) => {
                axios
                    //.post('/apps/customer/customers', { customer: customerData })
                    .post('/api/v1/Asset/eventgenerator/enginecoolanttemperature', alarm)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        addHydraulicOilTemperatureAlarm(ctx, alarm) {
            return new Promise((resolve, reject) => {
                axios
                    //.post('/apps/customer/customers', { customer: customerData })
                    .post('/api/v1/Asset/eventgenerator/hydraulicoiltemperature', alarm)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        addTransmissionOilTemperatureAlarm(ctx, alarm) {
            return new Promise((resolve, reject) => {
                axios
                    //.post('/apps/customer/customers', { customer: customerData })
                    .post('/api/v1/Asset/eventgenerator/transmissionoiltemperature', alarm)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        async fetchAlerts(ctx, queryParams) {
            try {
                const params = new URLSearchParams();

                if (queryParams.q) params.append('Search', queryParams.q);
                if (queryParams.ownerId) params.append('OwnerId', queryParams.ownerId);
                if (queryParams.assetId) params.append('AssetId', queryParams.assetId);
                if (queryParams.start) params.append('Start', queryParams.start);
                if (queryParams.end) params.append('End', queryParams.end);
                if (queryParams.page) params.append('Page', queryParams.page);
                if (queryParams.groupId) params.append('GroupId', queryParams.groupId);
                if (queryParams.virtualFenceId) params.append('virtualFenceId', queryParams.virtualFenceId);

                params.append('PerPage', queryParams.perPage ? String(queryParams.perPage) : '10');

                if (queryParams.alertIds?.length) {
                    queryParams.alertIds.forEach(id => params.append('EventTypes', id));
                }

                const response = await axios.get('/api/v1/Event/search', { params });
                return response;
            } catch (error) {
                throw error;
            }
        },
        fetchTypeAlerts(){
            return new Promise((resolve, reject) => {
                axios
                    //.get(`/apps/asset/assets/${id}`)
                    .get(`/api/v1/Event/searchtype`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        fetchFences(ctx, queryParams = {}) {
            return new Promise((resolve, reject) => {
                const { q = '', search = '', page = 1, perPage = 10 } = queryParams;
                const searchTerm = search || q || '';
                const params = {
                    Page: page,
                    PerPage: perPage,
                };
                if (searchTerm.trim()) {
                    params.Search = searchTerm.trim();
                }
                axios
                    .get('/api/v1/VirtualFence/search', { params })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        exportAlertsExcel(ctx, queryParams) {
            const params = new URLSearchParams();

            if (queryParams.q) params.append('Search', queryParams.q);
            if (queryParams.ownerId) params.append('OwnerId', queryParams.ownerId);
            if (queryParams.assetId) params.append('AssetId', queryParams.assetId);
            if (queryParams.start) params.append('Start', queryParams.start);
            if (queryParams.end) params.append('End', queryParams.end);
            if (queryParams.page) params.append('Page', queryParams.page);
            if (queryParams.groupId) params.append('GroupId', queryParams.groupId);
            if (queryParams.virtualFenceId) params.append('virtualFenceId', queryParams.virtualFenceId);

            params.append('PerPage', queryParams.perPage ? String(queryParams.perPage) : '10');

            if (queryParams.alertIds?.length) {
                queryParams.alertIds.forEach(id => params.append('EventTypes', id));
            }
            
            
            return new Promise((resolve, reject) => {
                axios({
                    url: `/api/v1/Event/searcheventexcel`,
                    method: 'GET',
                    responseType: 'blob',
                    params: params
                })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        

    },
}